import { useEffect, useState } from "react";

export default function useDevice() {
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    setIsIos(
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }, []);

  return { isIos };
}
